import { useEffect, useState } from "react";
import HubUsageSelectionFilterDialog from "./HubUsageSelectionFilterDialog";

export default function HubUsageUserFilterDialog(props) {
    const [selectedKeys, setSelectedKeys] = useState([]);

    useEffect(() => {
        if (props.users) {
            setSelectedKeys(
                props.users
                    .filter(
                        (user) =>
                            !props.excludedUserKeys.includes(user.key),
                    )
                    .map((user) => user.key),
            );
        }
    }, [props.users, props.excludedUserKeys, props.open]);

    function handleClose() {
        props.onClose(
            props.users
                .filter((user) => !selectedKeys.includes(user.key))
                .map((user) => user.key),
        );
    }

    function handleToggle(key) {
        setSelectedKeys(
            selectedKeys.includes(key)
                ? selectedKeys.filter((selectedKey) => selectedKey !== key)
                : [...selectedKeys, key],
        );
    }

    return (
        <HubUsageSelectionFilterDialog
            open={props.open}
            onClose={handleClose}
            title="User filter"
            items={props.users.map((user) => ({
                key: user.key,
                label: user.fullName,
            }))}
            selectedKeys={selectedKeys}
            onToggle={handleToggle}
            onToggleAll={() =>
                setSelectedKeys(
                    selectedKeys.length === props.users.length
                        ? []
                        : props.users.map((user) => user.key),
                )
            }
        />
    );
}
